import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Box, 
  TextField, 
  InputAdornment, 
  FormControlLabel, 
  Switch, 
  Button, 
  Typography, 
  Tooltip 
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CsvUploader from './CsvUploader';
import AnimatedIconButton from './AnimatedIconButton'; 
import ColumnSelectorModal from './ColumnSelectorModal'; 

export default function ToolbarSection({
  logo,
  searchTerm,
  handleDynamicSearch,
  handleResetClick,
  handleCsvUpload,
  fileUploaded,
  switchtoggle,
  handleCheckboxChange,
  csvData,
  isModalOpen,
  setModalOpen,
  handleColumnsSelect,
  setAboutOpen
}) {
  return (
    <AppBar position="static" sx={{ bgcolor: "#f2f6f0"}}>
      <Toolbar>
        <img src={logo} alt="Logo" style={{ height: '50px' }} />
        <TextField
          variant="outlined"
          sx={{ marginLeft: '10px', width: 1, maxWidth: '300px', backgroundColor: '#ffffff'}}
          size="small"
          placeholder="Search your node"
          input={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary"/>
              </InputAdornment>
            )
          }}
          value={searchTerm}
          onChange={handleDynamicSearch}
          style={{ marginRight: '10px' }}
        />
        <Box display="flex" alignItems="center">
          <Tooltip title="Reset" placement="bottom" arrow>
            <AnimatedIconButton color="inherit" style={{ marginLeft: '10px'}} onClick={handleResetClick}>
              <RestartAltIcon />
            </AnimatedIconButton>
          </Tooltip>
          <Tooltip title="Upload a file" placement="bottom" arrow>
            <AnimatedIconButton color="inherit" style={{ marginLeft: '10px'}}>
              <CsvUploader onUpload={handleCsvUpload} />
            </AnimatedIconButton>
          </Tooltip>
          <Tooltip title="Enable or Disable Breadth-First search" placement="bottom" arrow>
            <FormControlLabel
              control={
                <Switch
                  disabled={!fileUploaded}
                  value={switchtoggle.current}
                  onChange={handleCheckboxChange}
                  name="switch"
                  color="primary"
                />
              }
              style={{ marginLeft: '10px'}}
              label={  <Typography style={{ fontFamily: '"Courier New", monospace', fontWeight: 'bold' }}>
                BFS
              </Typography>}
            />
          </Tooltip>
        </Box>
        <ColumnSelectorModal
          columns={csvData.length > 0 ? Object.keys(csvData[0]) : []}
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          onSelect={handleColumnsSelect}
        />
        <Box sx={{ marginLeft: 'auto' }}>
          <Button color="inherit" onClick={() => setAboutOpen(true)}   style={{fontFamily: '"Courier New", monospace', fontWeight: 'bold'}}>About</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}